import React from "react";
import { component_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const labelConfig = WizTableForm.Config.label(this, {apiParams: {type: 12}})
let { WizModal } = component_tool;

//配置项
const componentName = "classStudentHomework";
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: '手机号',
    name: 'mobile',
    tableItem: {}
  },
  {
    title: "组织名称",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
    }
  },
  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },

  {
    title: "组织名称",
    name: "orgName",
    tableItem: {
      width: 150,
    }
  },
  {
    title: "组织代码",
    name: "orgCode",
    tableItem: {
      width: 120,
    },
  },
  {
    title: "岗位",
    name: "positionName",
    tableItem: {
      width: 100,
    }
  },
  {
    title: "任职状态",
    name: "jobState",
    dict: [
      { code: 0, codeName: '离职' },
      { code: 1, codeName: '在职' },
    ],
    tableItem: {
      width: 100,
    },
  },
  {
    title: "是否请假",
    name: "leaveState",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" }
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: '是否参加',
    name: 'isAttend',
    tableItem: {},
    dict: [
      { code: 0, codeName: "未参加" },
      { code: 1, codeName: "已参加" }
    ],
    formItem: {
      type: "radio",
      initialValue: 0
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "提交时间",
    name: "submitTime",
    tableItem: {
      width: 180,
    },
  },
  {
    title: "通过状态",
    name: "pass",
    dict: [
      { code: 0, codeName: '未通过' },
      { code: 1, codeName: '已通过' },
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "标签",
    name: "labelId",
    dataIndex: "labelId",
    searchItem: {
      ...labelConfig,
      diy: WizTableForm,
      selectType: 'radio',
    }
  },
  {
    title: "标签",
    name: "labelNames",
    dataIndex: "labelNames",
    width: 150,
    tableItem: {}
  },
  {
    title: "成绩",
    name: "score",
    tableItem: {
      width: 100,
    },
  },

];

const templateConfig = (date) => {
  const {onSelect,classInfoId,_btnLookUserFun,_this} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出作业记录', type:'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentHomework",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: true
        },
        rowOperateSort: ['showHomeworkRecord'],
        rowOperateView: [
          {
            key: "showHomeworkRecord",
            custom: true,
            params: {children: "查看作业"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "jumpPageShow",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                window.open('/#/homeworkRecord/homeworkRecordShow?id='+record.homeworkRecordId, '_blank');
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: true };
              if (record.record && record.record.submitState){
                result = {disabled: false}
              }
              return result
            },

          }
        ]
      }
    }
  }
};



let reduxTemplateCofig = args => {
  const { classInfoId ,entityId} = args;
  const apis = {
    list: {
      path: `${componentName}/queryClassStudentHomeworkPage`,
      payload: {
        key: `${componentName}@queryClassStudentHomeworkPage`,
        apiParams: { classInfoId: classInfoId,entityId: entityId}
      }
    },
    exportClassStudentHomework: {
      path: `${componentName}/exportClassStudentHomework`,
      payload: {
        key: `${componentName}@exportClassStudentHomework`,
        apiParams: { classInfoId: classInfoId,entityId: entityId}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
